import script from "./AddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AddButton.vue?vue&type=script&setup=true&lang=js"

import "./AddButton.vue?vue&type=style&index=0&id=3c4f068d&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c4f068d"]])

export default __exports__